import React from 'react';
import { Skeleton } from '@perch-labs/shrike';
import { Row, RowChild, RowBuffer } from 'styles';

interface Props {
  hasBottomBorder?: boolean;
  includesBuffer?: boolean;
  bufferWidth?: string;
  mobileBufferWidth?: string;
}

export const StandardRowLoading = ({
  hasBottomBorder,
  includesBuffer,
  bufferWidth,
  mobileBufferWidth,
}: Props) => {
  return (
    <Row hasBottomBorder={hasBottomBorder} data-testid="loading-row">
      {includesBuffer && (
        <RowBuffer width={bufferWidth} xsmall={{ width: mobileBufferWidth }} />
      )}
      <RowChild direction="column">
        <Skeleton width="100%" />
        <Skeleton width="100%" />
      </RowChild>
    </Row>
  );
};
